<div [class]="this.className">
    <div *ngFor="let button of buttons" class="btn-group-item">
        <itb-icon [tooltipText]="button.tooltipText" [className]="button.iconClassName" (click)="clickEvent(button.buttonName)" ></itb-icon>
    </div>
</div>
